<template>
  <div class="overflow-hidden">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && item.title"
        class="py-10 py-md-13 py-lg-16 position-relative item"
      >
        <v-row justify="center" align="center">
          <v-col cols="12" :md="item.img ? 6 : 8" :lg="item.img ? 5 : 7">
            <div class="primary--text text-h5 font-weight-bold">
              {{ item.title }}
            </div>

            <div v-if="mobile && item.img" class="mt-6 position-relative">
              <img
                class="d-block rounded mx-auto item-img"
                :src="files + item.img"
                :alt="item.title"
                :width="item.img_seal ? '85%' : '90%'"
              />

              <img
                v-if="item.img_seal"
                class="d-block item-img-seal"
                :src="files + item.img_seal"
              />
            </div>

            <div
              v-if="item.title_topics && topics.length"
              class="secondary--text text-h6 font-weight-bold mt-6"
            >
              {{ item.title_topics }}
            </div>

            <div class="mt-2">
              <template v-for="(topic, keyTopics) in topics">
                <TopicTemplate
                  :key="keyTopics"
                  v-if="topic"
                  :item="topic"
                  class="mt-2"
                />
              </template>
            </div>

            <div>
              <ButtonWidget
                v-if="informations.whatsapp_float"
                :href="informations.whatsapp_float"
                target="_blank"
                :align="mobile ? 'center' : 'left'"
                class="mt-6"
              >
                <v-icon size="18" left> fa-whatsapp </v-icon>
                ENTRAR EM CONTATO
              </ButtonWidget>
            </div>
          </v-col>

          <v-col
            v-if="!mobile && item.img"
            :class="{ 'pb-10 mb-md-10': item.img_seal }"
            md="6"
            lg="7"
          >
            <div class="position-relative">
              <img
                class="d-block rounded item-img"
                :src="files + item.img"
                :alt="item.title"
                :width="item.img_seal ? '85%' : '90%'"
              />

              <img
                v-if="item.img_seal"
                class="d-block item-img-seal"
                :src="files + item.img_seal"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TopicTemplate from "../templates/TopicTemplate.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "qualitySeal",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    topics() {
      if (!this.item.topics) return [];
      return JSON.parse(this.item.topics);
    },
    informations() {
      return this.$rest("informations").item;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    LoadingWidget,
    TopicTemplate,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &:before {
    background-image: url(../../assets/img/points-bg.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    height: 205px;
    left: 100%;
    pointer-events: none;
    position: absolute;
    top: -102px;
    width: 205px;
  }

  &-img-seal {
    position: absolute;
    right: 30px;
    bottom: -80px;
    width: 200px;

    @media screen and (max-width: 1264px) {
      width: 150px;
    }

    @media screen and (max-width: 960px) {
      bottom: -40px;
      right: -10px;
      width: 120px;
    }

    @media screen and (max-width: 600px) {
      bottom: -20px;
      width: 100px;
    }
  }
}
</style>
